import {useTranslation} from 'react-i18next';
import {TotalItem} from './TotalItem';
import {useDispatch, useSelector} from "react-redux";
import {setInstallmentParams, setOneTimePaymentInstallments} from "../../../store/tenant/slice";
import {Fragment, useEffect, useMemo} from "react";
import ServerData from "../../../common/serverData";
import {hideLoader, showLoader} from "../../../store/common/slice";
import ErrorsHandler from "../../../common/errors/handleErrors";
import Money from "../../../common/utils/money";

function OneTimeTotal({ payment, installmentsValue, onChange }) {

    const buildingId = useSelector(state => state.tenant.buildingID);
    const installmentParams = useSelector(state => state.tenant.installmentParams.oneTime);
    const paymentMethod = useSelector(state => state.tenant.paymentMethod);
    const dispatch = useDispatch();

    const client = useMemo(() => new ServerData(), []);

    useEffect(async () => {
        dispatch(showLoader);
        try {
            const oneTimePaymentSettingsId = payment.building_one_time_payment_id;
            const paymentType = 'one_time_payment';
            const amountInCents = Money.roundNumber(payment.amount_left.value * 100);
            const options = await client.tenants.payments.getInstallmentOptions(buildingId, paymentType, paymentMethod, amountInCents, { oneTimePaymentSettingsId });
            dispatch(setInstallmentParams({ paymentType, params: options, uid: payment.uid }));
        } catch (e) {
            ErrorsHandler.notifyClientError(e);
        } finally {
            dispatch(hideLoader);
        }

    }, [paymentMethod]);

    return (
        <Fragment>
            <div className='one-time-title'>{payment.payment_description}</div>
            <TotalItem
                currency={payment.amount_left?.currency}
                total={payment.amount_left?.value}
                installments={installmentsValue}
                installmentParams={installmentParams[payment.uid]}
                onInstallmentsChange={onChange}
            />
        </Fragment>
    )
}

export function SpecialCheckoutItem({ payments }) {

    const { t } = useTranslation();
    const dispatch = useDispatch();
    const installments = useSelector(state => state.tenant.installments.oneTime);

    function handleInstallmentsChange(installments, payment) {
        dispatch(setOneTimePaymentInstallments({ installments, payment }));
    }

    return (
        <div className='checkout'>
            <div className='checkout-title'>
                {t('payments.pay_one_time')}
            </div>
            {payments.map(payment => <OneTimeTotal
                key={payment.uid}
                payment={payment}
                installmentsValue={installments[payment.uid]}
                onChange={value => handleInstallmentsChange(value, payment)}
            />)}
        </div>
    )
}

